import { useQuery } from "@tanstack/react-query";
import {
  buildingStorageQuotaKey,
  getBuildingStorageQuota,
  parseBuildingStorageId,
} from "@/domains/documents/services/buildingStorageQuota";

export function useBuildingStorageQuota(buildingId: string, orgId?: string) {
  const numericId = parseBuildingStorageId(buildingId);
  return useQuery({
    queryKey: buildingStorageQuotaKey(buildingId, orgId),
    queryFn: () => getBuildingStorageQuota(numericId ?? ""),
    refetchOnMount: "always",
    enabled: numericId !== null && Boolean(orgId),
    refetchInterval: (query) =>
      query.state.status === "success" && query.state.data?.limitBytes === null ? false : 30_000,
  });
}
